// extracted by mini-css-extract-plugin
module.exports =  {"answer":"answer--EsXhg"};